import React from 'react';
import { Space, Switch, Tooltip } from 'antd';
import { useAtom } from 'jotai';
import { useSelector } from 'react-redux';
import { dimensionPanelAtom, metricPanelAtom, summaryPanelAtom } from '@src/atoms/panels';
import { isAppSPIEnabledSelector, isCDNAccountSelector } from '@store/common/selectors';
import { isAppModule } from '@utils/constants';
import { prefixedCheckFeature } from '@utils/platform/features/checkFeature';
import { compareOnTrendsModeSelector } from '@store/trends/base/selectors';
import { ToggleText, Header } from './styled';

const cf = prefixedCheckFeature('trends.sections');

function Panels() {
  const [summaryPanel, setSummaryPanel] = useAtom(summaryPanelAtom);
  const [metricPanel, setMetricPanel] = useAtom(metricPanelAtom);
  const [dimensionPanel, setDimensionPanel] = useAtom(dimensionPanelAtom);

  const isCDNAccount = useSelector(isCDNAccountSelector);
  const isAppSpiEnabled = useSelector(isAppSPIEnabledSelector);

  // override and disable summary on compare mode
  const compareMode = useSelector(compareOnTrendsModeSelector);

  const onToggleCheck = (setToggle) => (checked) => setToggle(checked);

  const enableForEi = !isAppModule && !isCDNAccount;
  const enableForApp = isAppModule && isAppSpiEnabled;

  return (
    <Space direction="vertical">
      <Header>Page Sections</Header>
      {(enableForEi || enableForApp) && cf('summary', true) && (
        <div>
          <Tooltip title={compareMode ? 'Disabled while on compare mode' : ''}>
            <Switch
              checked={summaryPanel && !compareMode}
              onChange={onToggleCheck(setSummaryPanel)}
              disabled={compareMode}
            />
            <ToggleText>Summary</ToggleText>
          </Tooltip>
        </div>
      )}
      <div>
        <Switch checked={metricPanel} onChange={onToggleCheck(setMetricPanel)} />
        <ToggleText>Diagnostics</ToggleText>
      </div>
      <div>
        <Switch checked={dimensionPanel} onChange={onToggleCheck(setDimensionPanel)} />
        <ToggleText>Dimensions</ToggleText>
      </div>
    </Space>
  );
}

export default Panels;
